module.exports = __webpack_public_path__ + "img/annie-bot.1062bfa5.png";